<template>
  <div style="margin-bottom: 60px;">
    <div class="flex items-center justify-center title-container">
      <div class="line-left m-r-20 flex-1"></div>
      <el-image style="width: 47px;height: auto;" :src="icon" />
      <div class="font-weight font-38 m-l-20 m-r-20" style=" color: #A40000;;">{{ title }}</div>
      <div class="line-right flex-1"></div>
    </div>
    <div class="bottom-line"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  padding: 0 70px;
  box-sizing: border-box;
}

.line-left {
  // width: 370px;
  height: 15px;
  background: linear-gradient(-90deg, #CC3B16 0%, rgba(253, 249, 239, 0) 100%);
}

.line-right {
  // width: 370px;
  height: 15px;
  background: linear-gradient(90deg, #CC3B16 0%, rgba(253, 249, 239, 0) 100%);
}

.bottom-line {
  margin-top: 18px;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 182, 177, 0.64) 32%, rgba(255, 182, 177, 0.52) 74%, rgba(255, 255, 255, 0) 100%);
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
  .font-38 {
    font-size: 30px !important;
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .title-container {
    padding: 0 20px;
  }
  .line-left {
    display: none;
  }

  .line-right {
    display: none;
  }

  // .bottom-line {
  //   width: 100%;
  // }
  .font-38 {
    font-size: 24px !important;
  }
}
</style>